import type { OrderDetails } from '@widgets/orders'

import { useCommonStore } from '@shared/model'
import { runApiGet } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'

import { useOrderStore } from '../model/store'

/** `GET /admin-api/orders/{order}` — header, info, items and the payment log of one order. */
export const useOrderShowApi = async (orderId: string | number): Promise<OrderDetails | null> => {
  const orderStore = useOrderStore()
  const commonStore = useCommonStore()

  return runApiGet<OrderDetails>(useAdminRoutes('admin.order.details', { order_id: orderId }), {
    setLoading: commonStore.setLoading,
    handle: (response) => {
      const order: OrderDetails = response.data
      orderStore.setOrder(order)
      return order
    },
  })
}
